"use client";

import { Badge } from "rizzui";
import cn from "@/utils/class-names";
import { EPushNotificationStatus } from "@/utilities/types/PushNotification";

const colorMap: Record<EPushNotificationStatus, string> = {
  [EPushNotificationStatus.DRAFT]:
    "bg-gray-100 text-gray-700 border-gray-200",
  [EPushNotificationStatus.SCHEDULED]:
    "bg-blue-50 text-blue-700 border-blue-200",
  [EPushNotificationStatus.SENDING]:
    "bg-yellow-50 text-yellow-700 border-yellow-200",
  [EPushNotificationStatus.SENT]:
    "bg-green-50 text-green-700 border-green-200",
  [EPushNotificationStatus.FAILED]:
    "bg-red-50 text-red-700 border-red-200",
  [EPushNotificationStatus.CANCELLED]:
    "bg-zinc-100 text-zinc-600 border-zinc-200",
};

const labelMap: Record<EPushNotificationStatus, string> = {
  [EPushNotificationStatus.DRAFT]: "Draft",
  [EPushNotificationStatus.SCHEDULED]: "Scheduled",
  [EPushNotificationStatus.SENDING]: "Sending",
  [EPushNotificationStatus.SENT]: "Sent",
  [EPushNotificationStatus.FAILED]: "Failed",
  [EPushNotificationStatus.CANCELLED]: "Cancelled",
};

export default function PushNotificationStatusCell({
  status,
  className,
}: {
  status: EPushNotificationStatus;
  className?: string;
}) {
  return (
    <Badge
      variant="flat"
      size="sm"
      className={cn(
        "font-medium capitalize border",
        colorMap[status] ?? colorMap[EPushNotificationStatus.DRAFT],
        className
      )}
    >
      {labelMap[status] ?? status}
    </Badge>
  );
}
